module.exports = __webpack_public_path__ + "static/media/tech-evolution.46c6d8c4.png";